import { gql, TypedDocumentNode } from "@apollo/client";
import type { RecentVisitClientGql, RecentVisitEntityTypeGql, RecentlyVisitedQueryVisit } from "./queries";

export type RecentVisitsMutationPayload = {
  success: boolean;
  message: string | null;
  recentVisits: RecentlyVisitedQueryVisit[];
};

export type RecordRecentVisitInput = {
  url: string;
  text: string;
  subtext?: string;
  image?: string;
  entityType: RecentVisitEntityTypeGql;
  entityId: string;
  client: Exclude<RecentVisitClientGql, "LOCAL_STORAGE_IMPORT">;
};

export type RecordRecentVisitResponse = {
  recordRecentVisit: RecentVisitsMutationPayload;
};

export type RecordRecentVisitVariables = {
  input: RecordRecentVisitInput;
};

export const RECORD_RECENT_VISIT_MUTATION: TypedDocumentNode<RecordRecentVisitResponse, RecordRecentVisitVariables> =
  gql`
    mutation RecordRecentVisit($input: BackofficeRecordRecentVisitInput!) {
      recordRecentVisit(input: $input) {
        success
        message
        recentVisits {
          id
          url
          text
          subtext
          image
          visitedAt
          entityType
          entityId
        }
      }
    }
  `;

export type RemoveRecentVisitResponse = {
  removeRecentVisit: RecentVisitsMutationPayload;
};

export type RemoveRecentVisitVariables = {
  entityType: RecentVisitEntityTypeGql;
  entityId: string;
};

export const REMOVE_RECENT_VISIT_MUTATION: TypedDocumentNode<RemoveRecentVisitResponse, RemoveRecentVisitVariables> =
  gql`
    mutation RemoveRecentVisit($entityType: BackofficeRecentVisitEntityType!, $entityId: String!) {
      removeRecentVisit(entityType: $entityType, entityId: $entityId) {
        success
        message
        recentVisits {
          id
          url
          text
          subtext
          image
          visitedAt
          entityType
          entityId
        }
      }
    }
  `;

export type ImportRecentVisitInput = {
  url: string;
  text: string;
  subtext?: string;
  image?: string;
  visitedAt: string;
  entityType?: RecentVisitEntityTypeGql;
  entityId?: string;
};

export type ImportRecentVisitsResponse = {
  importRecentVisits: RecentVisitsMutationPayload;
};

export type ImportRecentVisitsVariables = {
  visits: ImportRecentVisitInput[];
};

export const IMPORT_RECENT_VISITS_MUTATION: TypedDocumentNode<ImportRecentVisitsResponse, ImportRecentVisitsVariables> =
  gql`
    mutation ImportRecentVisits($visits: [BackofficeImportRecentVisitInput!]!) {
      importRecentVisits(visits: $visits) {
        success
        message
        recentVisits {
          id
          url
          text
          subtext
          image
          visitedAt
          entityType
          entityId
        }
      }
    }
  `;
